var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('table', [_c('caption', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("〈漫画家〉 東村 アキコ")]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("1975年")]), _vm._v(" "), _c('td', [_vm._v("宮崎県串間市生まれ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("1994年")]), _vm._v(" "), _c('td', [_vm._v("県立宮崎西高校卒業")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("同年")]), _vm._v(" "), _c('td', [_vm._v("金沢美術工芸大学 油画専攻入学。秋の学園祭「美大祭」でとり野菜みそと出会い、以降、虜に。")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("1998年")]), _vm._v(" "), _c('td', [_vm._v("同大 卒業"), _c('br'), _vm._v("卒業後、会社勤務の傍ら漫画創作活動を開始。"), _c('br'), _vm._v("ぶ～けデラックス増刊号「フルーツこうもり」で漫画家デビュー。")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("1999年")]), _vm._v(" "), _c('td', [_vm._v("ぶ～けデラックス増刊号「フルーツこうもり」で漫画家デビュー。")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("2001年")]), _vm._v(" "), _c('td', [_vm._v("Cookie「きせかえユカちゃん」連載開始、少女漫画家にしてギャク漫画家の才能をも開花させる。")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("2010年")]), _vm._v(" "), _c('td', [_vm._v("「海月姫」講談社漫画賞受賞")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("2012年")]), _vm._v(" "), _c('td', [_vm._v("「主に泣いてます」ドラマ化（CX）")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("2014年")]), _vm._v(" "), _c('td', [_vm._v("「海月姫」実写映画化")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("2015年")]), _vm._v(" "), _c('td', [_vm._v("自伝漫画「かくかくしかじか」がマンガ大賞2015および文化庁メディア芸術祭漫画部門大賞を、"), _c('br'), _vm._v("「東京タラレバ娘」がananマンガ大賞の大賞を受賞。")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("2017年")]), _vm._v(" "), _c('td', [_vm._v("「東京タラレバ娘」ドラマ化（NTV）")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("2013年〜")]), _vm._v(" "), _c('td', [_vm._v("京都精華大学・マンガ学部客員教授2014年より宮崎県「みやざき大使」")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("2017年〜")]), _vm._v(" "), _c('td', [_vm._v("金沢美大・油画専攻非常勤講師")])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("【その他の作品】")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("「ひまわりっ」 「ママはテンパリスト」 「メロポンだし！」 「雪花の虎」 「美食探偵 −明智五郎−」"), _c('br'), _vm._v("\n        「即席ビジンのつくりかた」他多数")])])])]), _vm._v(" "), _c('a', {
    staticClass: "btnBrandtop",
    attrs: {
      "href": "http://www.toriyasaimiso.jp/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_footer.svg"),
      "alt": "とり野菜みそオフィシャルサイトへ"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c69c552","hasScoped":true,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 94
// module chunks = 0